module.exports = __webpack_public_path__ + "static/media/CloseCircle.765ac3a1.svg";